export var textColor = function textColor(text, attrs) {
  return "{color:".concat(attrs.color, "}").concat(text, "{color}");
};